import { useState, useEffect, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';

import api from '../../../apis';
import moment from 'moment';


import { numberWithCommas } from '../../general/convertor';
import { Button, Form, Input, Tabs } from 'antd';
import UserAccTreeSelect from '../../general/form-control/user-acc-tree-select';
import TrustWithdrawalStatusTbl from '../../tables/TrustWithdrawalStatusTbl';
import MotionLayout from '../../general/framer-motion/MotionLayout';
import { FilterProvider } from '../../../context/FilterContext';
import TrustWithdrawalTbl from '../../tables/TrustWithdrawalTbl';
import CloseButton from '../../layouts/CloseButton';
import FilterInputBuilder from '../../filterInputBuilder/userFilter';//global state

import { siderWidth } from '../../../constants/layout'
import OpenButton from '../../layouts/OpenButton';
import { contentPadding } from '../../layouts/layoutHelper';

import { showMessageModal, showSuccessMessageModal } from '../../../components/utils';

const inputClass ="custom";

const Index = () => {
    const [tableLoading, setTableLoading] = useState(false);
    const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
    const items = [
        { label: 'Trust Amount', key: 'item-1', children: <><TrustWithdrawalTbl /></> }, // remember to pass the key prop
        { label: 'Trust Application Status', key: 'item-2', children: <><TrustWithdrawalStatusTbl /></> },
        // { label: 'Withdrawal', key: 'item-3', children: <WithdrawalTab /> },
    ];

    const handleSidebarToggle = () => {
        setIsSidebarCollapsed(!isSidebarCollapsed);
    };

    const filterColumns = [
        {
            type: "selectUser",
            singleMode: true,
        },
    ]


    return(<div className=''>
         <MotionLayout>
            <FilterProvider>
                <div className={`page-layout  ${isSidebarCollapsed ? 'collapsed' : ''}`}>
                    <div className="side-bar" style={{
                        width: isSidebarCollapsed ? '0' : siderWidth
                    }}>
                        <CloseButton 
                            handleClick={handleSidebarToggle}
                        />
                        <div className='content' style={{width:siderWidth}}>
                            <div className='pt-3'></div>
                            <FilterInputBuilder 
                                loading={tableLoading}
                                columns={filterColumns} 
                                initSearchWhenReceived={[`accounts[]`]}  
                                onSearchSubmit={(inputs:any)=>{
                                    let accounts = inputs['accounts[]'] || [];
                                }}
                            />
                        </div>
                    
                    </div>
                    <div className="main-content " style={{
                        marginLeft: isSidebarCollapsed ? '0px' : siderWidth,
                        paddingLeft: isSidebarCollapsed ? '0px' : '20px',
                    }}>
                        <OpenButton 
                            isSidebarCollapsed={isSidebarCollapsed}
                            handleClick={handleSidebarToggle}
                        />
                        <div className={ contentPadding(isSidebarCollapsed)}> 
                            <Tabs 
                                destroyInactiveTabPane={true}
                                items={items} 
                            />
                        </div>
                        
                    
                    </div>
                </div>
  
            </FilterProvider>
        </MotionLayout>
    </div>)
};

const WithdrawalTab = () => {
    const [form] = Form.useForm();
    const [currentAccNo, setCurrentAccNo] = useState('');
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        // requestSearchClientNameAccount();
    }, []);

    useEffect(() => {
       // console.log('currentAccNo',currentAccNo)
        requestGetTrustDetailAPI(currentAccNo);
    }, [currentAccNo]);

    const requestGetTrustDetailAPI = async (accNo: any) => {
        form.setFieldValue('currency_text', "");
        form.setFieldValue('at_curr_trdlimit', "");

        if(accNo){
          //  console.log('requestGetTrustDetailAPI');
            let result = await api.getTrustDetailOption(accNo);
          //  console.log("requestGetTrustDetailAPI result",result)
            if (result) {
                let at_curr_trdlimit = result.at_curr_trdlimit || 0;
                let c_code = result.c_code || '';

                form.setFieldValue('currency_text', c_code);
                form.setFieldValue('at_curr_trdlimit', at_curr_trdlimit);
               // setAvailTrustAmount(result.at_curr_trdlimit || 0);
                //setTableData(contra);
                //  updateAccSummaryComponent(account);
            }
        }
        
    };

    const onValuesChange = (values: any) => {   
       // console.log("onValuesChange",values);
        //map values to form fields
        form.setFieldsValue({
            currentAccNo: values["accounts[]"][0],
        });
        setCurrentAccNo(values["accounts[]"][0]);
    };

    const onFinishFailed = (errorInfo: any) => {
        console.log('Failed:', errorInfo);
    };

    const onFinish = async (values: any) => {
      //  console.log('Success:', values);

        setLoading(true);

        let result = await api.submitWithdrawal(currentAccNo, values);
        setLoading(false);
        if (result.status == 0) {
           // alert('Submit withdrawal successful');

            showSuccessMessageModal('Submit withdrawal successful');

            //refresh page
            navigate(0);
        } else {
          //  console.log(result);

            if (result?.message) {
                let message = result?.message;
                let sentence = '';

                for (var key of Object.keys(message)) {
                    sentence += message[key];
                }

              //  alert(sentence);

                showMessageModal(sentence);
            }
        }

    };
   return (<div className='p-5'>
                <div className='main-title text-center'>Withdrawal</div>
                <div className='d-flex pt-5  justify-content-center align-items-center  register-form'>
                    
                    <Form
                        form={form}
                        name="basic"
                        labelCol={{ span: 8 }}
                        wrapperCol={{ span: 8 }}
                        initialValues={{
                            date_requested: moment().format('DD/MM/YYYY'),
                            type:"Online Transfer"
                         }}
                        onFinish={onFinish}
                        onFinishFailed={onFinishFailed}
                        autoComplete="off"
                        size="large"
                        style={{width:'100%'}}
                    >
                        
                        <Form.Item
                            label="Username / Account No"
                            name="currentAccNo"
                            rules={[{ required: true, message: 'Please input' }]}
                        >
                             <UserAccTreeSelect
                            // mode={mode}
                            singleMode={true}
     

                            onSelectedDetails={(values:string,selectedDetails: string) =>
                            {
                                    // setCurrentAccNo(values);
                                    // setCurrentAccDetails(selectedDetails);
                                   // console.log("onValueChange",values,selectedDetails)
                                    onValuesChange({    
                                        "accounts[]":values,
                                        "accounts_details[]":selectedDetails
                                    });
                                    // if(onValuesChange){
                                    //     onValuesChange({
                                    //         "accounts[]":values,
                                    //         "accounts_details[]":selectedDetails
                                    //     });
                                    // }
                                
                            }
                            }
                        />
                        </Form.Item>

                        <Form.Item
                            label="Date Requested"
                            name="date_requested"
                            rules={[{ required: true, message: 'Please input' }]}
                        >
                            <Input className={inputClass} disabled/>
                        </Form.Item>
                        

                        <Form.Item
                            label="Currency"
                            name="currency_text"  
                        >
                            <Input className={inputClass} disabled/>
                        </Form.Item>

                        <Form.Item
                            label="Current Available Trust Amount"
                            name="at_curr_trdlimit"
                        >
                            <Input className={inputClass} disabled/>
                        </Form.Item>

                        

                        <Form.Item
                            label="Type"
                            name="type"
                            rules={[{ required: true, message: 'Please input' }]}
                        >
                            <Input  className={inputClass} disabled/>
                        </Form.Item>

                        <Form.Item
                            label="Withdrawal Amount"
                            name="amount"
                            rules={[
                                { 
                                    required: true, message: 'Please input',
                                },
                                {
                                    pattern: /^\d+$/,
                                    message: 'Only numbers are allowed!',
                                },
                            ]}
                        >
                            <Input  className={inputClass} />
                        </Form.Item>
                


                        <Form.Item wrapperCol={{ offset: 8, span: 16 }} className='pt-4'>
                        <div>
                            <Button type="primary" htmlType="submit" className='btn-primary-custom btn-md' loading={loading}>
                                Submit
                            </Button>
                        </div>
                        </Form.Item>
                    </Form>
                </div>
        </div>)
};


export default Index;
